"use client";

import { appConfig, navItems } from "@/lib/constants";
import { track } from "@trendmap/analytics/client";
import { LogEvents } from "@trendmap/analytics/events";
import { Button } from "@trendmap/ui/components/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@trendmap/ui/components/popover";
import { cn } from "@trendmap/ui/lib/utils";
import Link from "next/link";
import { useRouter } from "next/navigation";
import React from "react";
import { Container } from "./container";
import { Logo } from "./logo";
import { NavLink } from "./nav-link";

export const Header = () => {
  const router = useRouter();

  const handlePlatformJump = () => {
    track({ event: LogEvents.PlatformJump.name });
    router.push(process.env.NEXT_PUBLIC_PLATFORM_APP_URL ?? "/");
  };

  return (
    <header className="py-10">
      <Container constrained>
        <nav className="relative z-50 flex justify-between">
          <div className="flex items-center md:gap-x-12">
            <Link href="#" aria-label="Home">
              <Logo />
            </Link>
            <div className="hidden md:flex md:gap-x-6">
              {navItems.map((navItem) => {
                return (
                  <NavLink key={navItem.href} href={navItem.href}>
                    {navItem.title}
                  </NavLink>
                );
              })}
            </div>
          </div>
          <div className="flex items-center gap-x-5 md:gap-x-8">
            <Button
              className="rounded-full"
              onClick={() => handlePlatformJump()}
            >
              Login
            </Button>
            <div className="-mr-1 md:hidden">
              <MobileNavigation />
            </div>
          </div>
        </nav>
      </Container>
    </header>
  );
};

function MobileNavIcon({ open }: { open: boolean }) {
  return (
    <svg
      aria-hidden="true"
      className="h-3.5 w-3.5 overflow-visible stroke-slate-700"
      fill="none"
      strokeWidth={2}
      strokeLinecap="round"
    >
      <path
        d="M0 1H14M0 7H14M0 13H14"
        className={cn("origin-center transition", open && "scale-90 opacity-0")}
      />
      <path
        d="M2 2L12 12M12 2L2 12"
        className={cn(
          "origin-center transition",
          !open && "scale-90 opacity-0",
        )}
      />
    </svg>
  );
}

function MobileNavigation() {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Popover open={open} onOpenChange={(open) => setOpen(open)}>
        <PopoverTrigger
          className="flex h-8 w-8 items-center justify-center ui-not-focus-visible:outline-none"
          aria-label="Toggle Navigation"
        >
          <MobileNavIcon open={open} />
        </PopoverTrigger>
        <PopoverContent className="w-[calc(100vw-2rem)] m-4 rounded-2xl bg-white p-4 text-lg tracking-tight text-slate-900 shadow-xl ring-1 ring-slate-900/5">
          <div className="w-full flex flex-col">
            {navItems.map((navItem) => {
              return (
                <a
                  key={navItem.href}
                  href={navItem.href}
                  className="block w-full p-2"
                >
                  {navItem.title}
                </a>
              );
            })}
          </div>
        </PopoverContent>
      </Popover>
    </>
  );
}
